import axios from "axios";
import { hostServer } from "./consts/host";
import { format, addSeconds, differenceInSeconds } from "date-fns";

export const toIsoStringTillSec = date =>
  format(date, "YYYY-MM-DDTHH:mm:ss") + "Z";

export const setDcConnectivity = connectivity => ({
  type: "SET_DC_CONNECTIVITY",
  connectivity
});

export const setDcNames = dcs => ({
  type: "SET_DC_DCS",
  dcs
});

export const setHistory = history => ({
  type: "SET_HISTORY",
  history
});

export const startSetDcFromHistory = (date, interval = 300) => {
  return async (dispatch, getState) => {
    const formatedMoment = format(date, "YYYY-MM-DD HH:mm:ss");
    const intervalAddedMoment = format(
      addSeconds(date, interval),
      "YYYY-MM-DD HH:mm:ss"
    );
    const res = await axios.get(
      `${hostServer}/api/v1/datacenters/metric_by_interval?from=${formatedMoment}&to=${intervalAddedMoment}&interval=${interval}`
    );
    dispatch(
      setDcConnectivity(res.data[toIsoStringTillSec(date)].connectivity)
    );
    dispatch(setDcNames(res.data[toIsoStringTillSec(date)].datacenters));
  };
};

export const startSetDc = () => {
  return async (dispatch, getState) => {
    const res = await axios.get(`${hostServer}/api/v1/datacenters/metric`);
    dispatch(setDcConnectivity(res.data.connectivity));
    dispatch(setDcNames(res.data.datacenters));
  };
};

export const startGetHistory = (startDate, EndDate, interval = 300) => {
  return async (dispatch, getState) => {
    const numOfReqs = Math.ceil(
      differenceInSeconds(EndDate, startDate) / interval / 24
    );

    for (var i = 0; i < numOfReqs; i++) {
      const res = await axios.get(
        `${hostServer}/api/v1/datacenters/metric_by_interval?from=${format(
          addSeconds(startDate, 24 * interval * i),
          "YYYY-MM-DD HH:mm:ss"
        )}&to=${format(
          addSeconds(startDate, 24 * interval * (i + 1)),
          "YYYY-MM-DD HH:mm:ss"
        )}&interval=${interval}`
      );
      dispatch(setHistory(res.data));
    }
  };
};
